<div class="latest-news-block" role="region" aria-label="Latest News" *ngIf="newsData && newsData.length > 0">
  <div class="latest-news-title">
    <div class="news-title-row">
      <h1 class="news-title" role="heading" aria-level="2" tabindex="0">News</h1>
      <div
        role="button"
        tabindex="0"
        class="news-archive"
        (click)="gotoNewsList()"
        (keydown)="($event.key === 'Enter' || $event.key === ' ') && gotoNewsList()"
        aria-label="View news archive"
      >
        <svg width="32" height="12" viewBox="0 0 32 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M26.2603 1.67969L30.5803 5.99916L26.2603 10.3197"
            stroke="#193062"
            stroke-width="2"
            stroke-linecap="round"
          />
          <rect x="0.339844" y="4.91895" width="31.32" height="2.16" rx="1" fill="#193062" />
        </svg>

        <div class="btn-view">
          <div class="btn-view-txt">View News Archive</div>
        </div>
      </div>
    </div>
    <div class="title-border"></div>
  </div>
  <ul class="latest-news-list">
    <li class="latest-news-item" *ngFor="let news of newsData | slice: 0 : 3">
      <a
        href="javascript:void(0)"
        (click)="gotoNewsDetail($event, news.title, news.id)"
        class="latest-news-link"
        [attr.aria-label]="news.title"
        tabindex="0"
        role="link"
      >
        <figure class="latest-news-image">
          <img
            data-src="{{
              news.imageDetails1?.src ? news.imageDetails1?.src : '../../../../../assets/images/default-img.png'
            }}"
            alt="{{ news.imageDetails1?.alt }}"
            data-object-fit="cover"
            width="619"
            height="620"
            class="loaded"
            src="{{
              news.imageDetails1?.src ? news.imageDetails1?.src : '../../../../../assets/images/default-img.png'
            }}"
            loading="eager"
          />
        </figure>
        <div class="latest-news-column">
          <div class="latest-news-title" role="heading" aria-level="3">
            <p class="latest-news-posteddate">{{ news.revisedDate }}</p>
            <h3>{{ news.title }}</h3>
            <p class="read-more">Read More</p>
          </div>
        </div>
      </a>
    </li>
  </ul>
</div>
